import type { ButtonTextVariant } from '@kanda-libs/ks-design-library';

export const FORM_STEPS = {
  WELCOME: 'Welcome',
  DISCLAIMER: 'Disclaimer',
  ACCEPT_TERMS: 'Accept terms',
  YOUR_INFO: 'Your info',
};

export const FORM_STEPS_KEYS = Object.values(FORM_STEPS);

export const DEFAULT_NEXT_BUTTON_PROPS = {
  id: 'apply-for-finance-next-button',
  label: 'Next',
  className: 'w-full',
  icon: 'arrow-right',
  variant: 'gradient' as ButtonTextVariant,
  submit: true,
};
